/** Shared app theme tokens. CSS variables in index.css are the source of truth. */
export const APP_THEME = {
  light: {
    bg: '#f8fafc',
    surface: '#ffffff',
    card: '#ffffff',
    header: '#ffffff',
    footer: '#f1f5f9',
    nav: '#ffffff',
    text: '#0f172a',
    muted: '#64748b',
    border: '#e2e8f0',
    accent: '#2563eb',
  },
  dark: {
    bg: '#0f172a',
    surface: '#1e293b',
    card: '#1e293b',
    header: '#1e293b',
    footer: '#1e293b',
    nav: '#1e293b',
    text: '#f8fafc',
    muted: '#94a3b8',
    border: '#334155',
    accent: '#3b82f6',
  },
};

export const getAppTheme = (isDarkMode) => (isDarkMode ? APP_THEME.dark : APP_THEME.light);
